/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

/* Components */
import ConversionFlow from './components/ConversionFlow';

/* utilities */
import parseDataToProps from 'js/utilities/parseDataToProps';

const conversionFlowNodes = Array.from(document.querySelectorAll('.conversion-flow'));

[...conversionFlowNodes].forEach((node) => {
    const root = createRoot(node);
    root.render(<ConversionFlow {...parseDataToProps(node.dataset)} />);
});
